import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { fromStaticDataCountriesForSettingsActions } from '../actions';
import { IStaticDataCountriesResponse } from '../models/static-data-countries.model';

export const staticDataCountriesForSettingsFeatureKey = 'staticDataCountriesForSettings';

export interface StaticDataCountriesForSettingsState {
  loadStaticDataCountriesForSettings: void;
  loadStaticDataCountriesForSettingsResponse: IStaticDataCountriesResponse[];
  loadStaticDataCountriesForSettingsFailure: IGenericError<ErrorResponse>;
}

export const initialState: StaticDataCountriesForSettingsState = {
  loadStaticDataCountriesForSettings: undefined,
  loadStaticDataCountriesForSettingsResponse: undefined,
  loadStaticDataCountriesForSettingsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataCountriesForSettingsActions.loadStaticDataCountriesForSettings, (state, action) => ({
    ...state,
    loadStaticDataCountriesForSettings: null
  })),

  on(fromStaticDataCountriesForSettingsActions.loadStaticDataCountriesForSettingsSuccess, (state, action) => ({
    ...state,
    loadStaticDataCountriesForSettingsResponse: action.response
  })),

  on(fromStaticDataCountriesForSettingsActions.loadStaticDataCountriesForSettingsFailure, (state, action) => ({
    ...state,
    loadStaticDataCountriesForSettingsFailure: action.error
  }))
);

export const getStaticDataCountriesForSettingsResponse = (state: StaticDataCountriesForSettingsState) =>
  state.loadStaticDataCountriesForSettingsResponse;
export const getStaticDataCountriesForSettingsFailure = (state: StaticDataCountriesForSettingsState) =>
  state.loadStaticDataCountriesForSettingsFailure;
